import VueRouter from "vue-router";

const patch = () => {
  const originalPush = VueRouter.prototype.push;
  VueRouter.prototype.push = function push(location, resolve, reject) {
    if (resolve || reject)
      return originalPush.call(this, location, resolve, reject);
    return originalPush.call(this, location).catch(() => {});
  };
};

export { patch };



// WEBPACK FOOTER //
// ./src/utils/patch.js